import React, { useContext, useEffect, useState } from 'react';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import LazyLoading from '../../../components/LazyLoading';
import { AppContext } from '../../../contexts/AppContext';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import { toast } from 'react-toastify';
import useBatchTypeService from '../../../app/services/hooks/useBatchTypeService';
import { BatchType, defaultBatchTypeDataForm } from '../../../app/models/BatchType';
import BatchTypeFormContainer from './BatchTypeFormContainer';

interface Props {
    batchTypeId: number;
    onSaved?: () => void;
    onCancel?: () => void;
    onError?: () => void;
}

const BatchTypeEdit = ({ batchTypeId, onSaved, onCancel, onError }: Props) => {
    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);
    const { fetchingEditBatchType, editBatchType, fetchingUpdateBatchType, updateBatchType } =
        useBatchTypeService();
    const [BatchType, setBatchType] = useState<BatchType>(defaultBatchTypeDataForm);
    const [errorFields, setErrorFields] = useState<any>();

    useEffect(() => {
        edit();
    }, []);

    const edit = () => {
        if (showLoading) showLoading('loading', 'Cargando tipo de lote...');
        editBatchType(batchTypeId, {
            onSuccess: (response: ServiceResponse) => {
                setBatchType(response.data.batch_type);
                if (hideLoading) hideLoading();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                toast.error(response.message);
                if (onError) onError();
            }
        });
    };

    const update = () => {
        if (showLoading) showLoading('loading', 'Actualizando tipo de lote...');
        updateBatchType(batchTypeId, BatchType, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                useReactConfirmAlert().successAlert({
                    title: 'Éxito',
                    message: response.message
                });
                toast.success(response.message, {
                    autoClose: 2500
                });
                if (onSaved) onSaved();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
            },
            onFieldError: (errorFields: ServiceResponse) => {
                if (hideLoading) hideLoading();
                setErrorFields(errorFields.data);
            }
        });
    };

    const cancel = () => {
        if (onCancel) onCancel();
    };

    return fetchingEditBatchType ? (
        <LazyLoading height="300" />
    ) : (
        <BatchTypeFormContainer
            fetching={fetchingUpdateBatchType}
            batchType={BatchType}
            setBatchType={setBatchType}
            action={update}
            cancel={cancel}
            errorFields={errorFields}
        />
    );
};

export default BatchTypeEdit;
